import { UserApi } from '@linktivity/triplabo-taxi';

import config from '../config';

const user = new UserApi(config);

export default user;
